import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as M from "materialize-css/dist/js/materialize";
import { Location } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';

import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-agregar-corral',
  templateUrl: './agregar-corral.component.html',
  styleUrls: ['./agregar-corral.component.css']
})
export class AgregarCorralComponent implements OnInit {

    idlote : string;
    lote : string;
    idGalpon : number;
    idGranja : number;
    idLevante : number;
    idLinea : number;
    idProduccion : number;
    online : boolean = true;
    corrales : any = [];
    corrales_name : any = [];
    alert_message : string;
    confirm_message : string;
    instance : any;
    instance_confirm : any;
    falta_subir_corral : any;
    corrales_offline : any;
    corral_offline : any;
    btnGuardar : boolean = true;
    @ViewChild('nombre') nombre;

  constructor(
      private http: HttpClient,
      private route: ActivatedRoute,
      private router: Router,
      public resource: ResourcesService,
      private _location: Location
  ) {
      let user = localStorage.getItem('user')
      if (user == undefined) {
          this.router.navigate(['/']);
          return
      } else {
          this.route.paramMap.subscribe(params => {
              this.idlote = params.get('idlote');

              // TRAER TODOS LOS CORRALES
              if (this.idlote == null) {
                  this.router.navigate(['/lotes']);
                  return;
              }

              var url_corrales = resource.route+'/corrales/'+this.idlote;
              this.http.get(resource.route+'/lotes/name/'+this.idlote).subscribe(
                  (data: any) => {
                      this.lote = data[0]['lote']
                  },
                  error => {
                      var corrales = localStorage.getItem('corrales')
                      this.corrales_offline = JSON.parse(corrales)
                      for (let i = 0; i < this.corrales_offline.length; i++) {
                          if (this.corrales_offline[i]['idlote'] == Number(this.idlote)) {
                              if (this.lote == undefined) {
                                  this.lote = this.corrales_offline[i]['lote']
                                  this.idGalpon = this.corrales_offline[i]['idGalpon']
                                  this.idGranja = this.corrales_offline[i]['idGranja']
                                  this.idLevante = this.corrales_offline[i]['idLevante']
                                  this.idLinea = this.corrales_offline[i]['idLinea']
                                  this.idProduccion = this.corrales_offline[i]['idProduccion']
                              }
                          }
                      }
                  }
              );
              this.http.get(url_corrales).subscribe(
                  (data: any) => {
                      this.corrales = data;
                      for (let i = 0; i < this.corrales.length; i++) {
                          this.corrales_name.push(this.corrales[i]['corral'])
                      }
                      resource.updateLocalStorageFromOnline()
                  },
                  error => {
                      this.online = false
                      var corrales = localStorage.getItem('corrales')
                      corrales = JSON.parse(corrales)
                      for (let i = 0; i < corrales.length; i++) {
                          if (corrales[i]['idlote'] == this.idlote) {
                              this.corrales.push(corrales[i])
                              this.corrales_name.push(corrales[i]['corral'])
                          }
                      }
                  }
              );
          });
      }

  }

  ngOnInit(): void {
  }

  alert(texto) {
      this.alert_message = texto;
      var elem= document.querySelector('.modal');
      this.instance = M.Modal.init(elem);
      this.instance.open();
  }

  confirm(texto) {
      this.confirm_message = texto;
      var elem= document.querySelector('.confirm');
      this.instance_confirm = M.Modal.init(elem);
      this.instance_confirm.open();
  }

  close() {
      this.instance.close();
  }

  close_confirm() {
      this.instance_confirm.close();
  }

  registrar() {
      if (this.nombre.nativeElement.value == '') return;
      if (this.corrales_name.includes(this.nombre.nativeElement.value)) {
          this.alert('Ya existe un corral con ese nombre');
          return;
      }
      var corral_data = {
          id : uuidv4(),
          corral : this.nombre.nativeElement.value,
          idlote : this.idlote
      }
      this.btnGuardar = false;
      return this.http.post(this.resource.route+'/corrales/', corral_data).subscribe(
          (data: any) => {
              this.router.navigate(['/corrales/'+this.idlote]);
          },
          error => {
              var ultimo = this.corrales_offline.length - 1;
              var falta_json = localStorage.getItem('falta_subir_corral')
              if (falta_json == '' || falta_json == undefined || falta_json == 'undefined') {
                  this.falta_subir_corral = []
              } else {
                  this.falta_subir_corral = JSON.parse(falta_json)
              }
              this.falta_subir_corral.push(corral_data)
              localStorage.setItem('falta_subir_corral', JSON.stringify(this.falta_subir_corral));

              var today = new Date();
              var nuevo_correlativo = this.corrales_offline[ultimo]['CorrelativoLote'] + 1;
              var mes = '';
              if ((today.getMonth()+1) < 10) {
                  mes = '0'+(today.getMonth()+1);
              } else {
                  mes = (today.getMonth()+1).toString();
              }
              var dia = '';
              if (today.getDate() < 10) {
                  dia = '0'+today.getDate();
              } else {
                  dia = today.getDate().toString();
              }
              var nuevo_corral = {
                CorrelativoLote: nuevo_correlativo,
                Estado: "1",
                FecEncaseta: "2019-09-22T05:00:00.000Z",
                FecinicioProd: null,
                Galpon: "3",
                NumHembras: 3371,
                Num_Aves_Fin_Levante: 484,
                SeleccionGenetica: 1,
                Sexo: "M",
                TipoGenero: "LM",
                TipoLote: "L",
                corral: corral_data.corral,
                fecha_creacion: today.getFullYear()+'-'+mes+'-'+dia+"T17:30:50.000Z",
                id: corral_data.id,
                idGalpon: this.idGalpon,
                idGranja: this.idGranja,
                idLevante: this.idLevante,
                idLinea: this.idLinea,
                idLote: Number(this.idlote),
                idProduccion: this.idProduccion,
                idlote: Number(this.idlote),
                lote: this.lote,
                lote_str: this.lote,
                online: 0
            }
              this.corral_offline = localStorage.getItem('corrales')
              if (this.corral_offline == '' || this.corral_offline == undefined) {
                  this.corral_offline = []
              } else {
                  this.corral_offline = JSON.parse(this.corral_offline)
              }
              this.corral_offline.push(nuevo_corral)
              localStorage.setItem('corrales', JSON.stringify(this.corral_offline));
              this.router.navigate(['/corrales/'+this.idlote]);
          }
      );
  }
  confirmar() {
      this.router.navigate(['/corrales/'+this.idlote]);
  }
  regresar() {
      this._location.back();
  }

}
